export const DEFAULT_APP_NAME = "Hat Bakım Yapısal Atölyesi İzin Takvimi";
export const PREVIOUS_DEFAULT_APP_NAME = "THY Hat Bakım Kompozit İzin Takvimi";
export const PWA_SHORT_NAME = "Yapısal İzin";
